import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { MessageModalComponent } from './components/message-modal/message-modal.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [MessageModalComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  private translateService = inject(TranslateService);

  ngOnInit(): void {
    this.translateService.addLangs(environment.availableLangs);
    this.translateService.setDefaultLang('en');
    this.translateService.use('en');
    window.lang = this.translateService.currentLang;

    console.log(`API URL: ${environment.apiURL}`);
  }
}
